import { render, staticRenderFns } from "./FixedBottomBtn.vue?vue&type=template&id=3a805353"
import script from "./FixedBottomBtn.vue?vue&type=script&lang=js"
export * from "./FixedBottomBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports